import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

function render(container, devices) {
    ReactDOM.render(<App devices={devices}/>, container);
}

window.Airgloss = {
    render
};

// EXAMPLE

const devices = [
    {
        serial: 'AP007ZAN',
        room: 'Office (Device 1)'
    },
    {
        serial: 'AP001ZAN',
        room: 'Office (Device 2)'
    },
    {
        serial: 'AP046ZAN',
        room: 'Office (Device 3)'
    },
    {
        serial: 'AP064ZAN',
        room: 'Office (Device 4)'
    },
    {
        serial: 'AP060ZAN',
        room: 'Office (Device 5)'
    },
];

window.Airgloss.render(
    document.getElementById('root'),
    devices
);

